import algoliasearch from 'algoliasearch/lite';

//export const searchClient = algoliasearch(
//  'latency',
//  '6be0576ff61c053d5f9a3225e2a90f76'
//);

export const searchClient = algoliasearch(
  'S5P0H0FXZA',
  '8d6246c16b650b0a32db91c63bc5ccee'
);
